import request from '@/utils/request'
import { Message } from 'element-ui'

// const header = { 'content-type': 'application/json' }
// const token_type = 'Bearer'
// const acc_token = ''
// const acc_token_header_key = 'Authorization'

/**
 * 直播间详情
 * @param {Number} id  直播间id
 */
export const getLive = async (id) => {
  const data = await request({
    url: `/live/get/${id}`,
    method: 'GET'
  })
  if (!data.success) {
    Message.error(data.message || '直播间获取失败')
    return Promise.reject(new Error(data.message || '直播间获取失败'))
  }
  return data
}
